export default __webpack_public_path__ + "static/media/caretaker-1.7042162a.svg";